export const FILTERS_ERROR_ANALYTICS = 'directories.filters.error';
